import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
  MenuItem
} from "@mui/material";

interface CargoDialogProps {
  open: boolean;
  onClose: () => void;
  workerName?: string;
  currentDebt: number;
  onSubmit: (amount: number, detail: string) => Promise<void>;
}

export default function CargoDialog({ open, onClose, workerName, currentDebt, onSubmit }: CargoDialogProps) {
  const [amountRaw, setAmountRaw] = useState<number | "">("");
  const [detail, setDetail] = useState("Consumo / Ajuste manual");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setAmountRaw("");
      setDetail("Consumo / Ajuste manual");
    }
  }, [open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const val = amountRaw === "" ? 0 : amountRaw;
    if (!val || val <= 0 || !detail) return;
    setLoading(true);
    try {
      await onSubmit(val, detail);
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          <Typography variant="h6" fontWeight={700}>
            Cargar Deuda Manual
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {workerName} - Deuda actual: ${currentDebt.toLocaleString()}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2} pt={1}>
            <TextField
              label="Monto a Cargar"
              type="text"
              value={amountRaw !== "" ? amountRaw.toLocaleString() : ""}
              onChange={(e) => {
                const rawStr = e.target.value.replace(/\D/g, "");
                setAmountRaw(rawStr ? Number(rawStr) : "");
              }}
              required
              fullWidth
              size="small"
            />
            <TextField
              label="Motivo / Detalle"
              value={detail}
              onChange={(e) => setDetail(e.target.value)}
              required
              fullWidth
              size="small"
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit">Cancelar</Button>
          <Button type="submit" variant="contained" color="warning" disabled={loading || amountRaw === ""}>
            {loading ? "Procesando..." : "Cargar a Deuda"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
